var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderLeftArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.43359 0C9.11263 0 8.86718 0.261368 8.86718 0.603158V2.61368C8.86718 2.73432 8.79166 2.81474 8.67838 2.81474H1.90035L2.46675 2.25179C2.69332 2.03063 2.7122 1.64863 2.48564 1.40737C2.25907 1.16611 1.91923 1.146 1.69266 1.38726L0.238878 2.85495C-0.0632075 3.15653 -0.0820877 3.65916 0.201117 3.98084C0.219997 4.00095 0.219997 4.00095 0.238878 4.02105L1.69266 5.48874C1.91923 5.70989 2.27795 5.7099 2.48564 5.46863C2.69332 5.22737 2.69332 4.84537 2.46675 4.62421L1.90035 4.06126H8.67838C9.41471 4.06126 10 3.438 10 2.65389V0.603158C10 0.261368 9.75456 0 9.43359 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLeftArrowIcon);
export default __webpack_public_path__ + "static/media/headerLeftArrowIcon.8d63e817362a9b0b2f0bdfb22446e154.svg";
export { ForwardRef as ReactComponent };